import { useIsSetupOptionEnabled } from '@/helpers/hooks/useIsSetupOptionEnabled/useIsSetupOptionEnabled';
import { useSetupOption } from '@/helpers/hooks/useSetupOption/useSetupOption';
import { SERVICE } from '@/modules/config';

export const useServiceRequestLightSetupOption = (setupOption: string) =>
  useIsSetupOptionEnabled(setupOption, SERVICE.SERVICE_REQUEST_LIGHT);

export const useServiceRequestLightSetupOptionValue = (setupOption: string) =>
  useSetupOption(setupOption, SERVICE.SERVICE_REQUEST_LIGHT);
